import { render, staticRenderFns } from "./PrivacyPolicyDialog.vue?vue&type=template&id=2a13d1f4"
import script from "./PrivacyPolicyDialog.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports